import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function candlesBackGreaterThan1Builder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Candles back cannot be greater than one when using the Minute time
        frame. Current candles back: {parsedStatusObj.candlesBack}.
      </Body3>
    </td>
  );
}
